var React = require('react');

function AutoLocIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zM8 5.349 9.248 8H6.753L8 5.349zm3.095 6.577L10.19 10H5.811l-.906 1.926a1 1 0 1 1-1.81-.852l3.548-7.538c.54-1.149 2.174-1.149 2.714 0l3.548 7.538a1 1 0 0 1-1.81.852z","fill":"#fff"}));
}

AutoLocIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = AutoLocIcon;

AutoLocIcon.default = AutoLocIcon;
